// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "fancyappscss" + "." + chunkId + "." + "b32cfe44ef34ceb66e0c" + ".css";
};